import React from 'react';
import PropTypes from 'prop-types';

import { FormattedMessageWrappedInSpan, FormattedPrice } from '../../misc';
import { trackEvent } from '../../../utils/ga-tracking';

class FotoFlatOffer extends React.PureComponent {
  constructor(props) {
    super(props);

    this.scrollToImpressions = this.scrollToImpressions.bind(this);
    this.scrollToVoucher = this.scrollToVoucher.bind(this);
  }

  scrollToImpressions(event) {
    event.stopPropagation();
    this.props.onScrollToImpressions();
  }

  scrollToVoucher(event) {
    event.stopPropagation();
    this.props.onScrollToVoucher();
  }

  render() {
    const {
      offer,
      participantMediaCount,
      impressionMediaCount,
      onBuyFotoFlatClick,
    } = this.props;

    return (
      <div className="fotoflat-offer-container pricelist-container medialist-item-container">
        <div className="pricelist">
          <div className="pricelist-header">
            <FormattedMessageWrappedInSpan
              id="global.fotoFlat"
              defaultMessage="Foto-Flat"
            />
          </div>
          <div className="pricelist-body">
            <div className="pricelist-item">
              <FormattedMessageWrappedInSpan
                id="fotoFlatOffer.personalPhotos"
                defaultMessage="All {count} personal digital fotos (JPG)"
                values={{ count: participantMediaCount }}
              />
            </div>
            {impressionMediaCount > 0 && (
              <div
                className="pricelist-item pricelist-item-impressions"
                onClick={this.scrollToImpressions}
              >
                <FormattedMessageWrappedInSpan
                  id="fotoFlatOffer.impressionPhotos"
                  defaultMessage="All {count} digital impressions (JPG)"
                  values={{ count: impressionMediaCount }}
                />
                <span className="icon eye" />
              </div>
            )}
            {offer.voucher && (
              <div
                className="pricelist-item pricelist-item-voucher"
                onClick={this.scrollToVoucher}
              >
                <div
                  dangerouslySetInnerHTML={{
                    __html: offer.voucher.shortText,
                  }}
                />
                <span className="icon eye" />
              </div>
            )}
          </div>
          <div
            className="pricelist-main-price"
            onClick={() => {
              trackEvent('Event', 'Buy', 'Foto-Flat banner');
              onBuyFotoFlatClick();
            }}
          >
            <div>
              <FormattedMessageWrappedInSpan
                id="fotoFlatOffer.buyButton"
                defaultMessage="Buy now"
              />
              <FormattedPrice price={offer.price} />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

FotoFlatOffer.propTypes = {
  participantMediaCount: PropTypes.number,
  impressionMediaCount: PropTypes.number,
  offer: PropTypes.shape({
    id: PropTypes.string,
    price: PropTypes.object,
    voucher: PropTypes.object,
  }),
  onBuyFotoFlatClick: PropTypes.func,
  onScrollToImpressions: PropTypes.func,
  onScrollToVoucher: PropTypes.func,
};

export default FotoFlatOffer;
